<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-18",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 18,
      nextPage: '/questionnaire/section1/19',
      navigateType: 'CLICK_NEXT',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/Menopause.png'),
        mainTitle: 'Do you have any of the following symptoms?',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'Night sweat',
            },{
              text: 'Hot flash',
            }
          ],[
            {
              text: 'Anxiety',
            },{
              text: 'Weight gain',
            }
          ]
        ],
        hasInput: true
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
